import { Hotel, MapPin, Calendar, Bed, Users, Coffee, Building2 } from 'lucide-react';

const EditHotel = ({ voucherData, t, formatDate, styles }) => {
  const hotel = voucherData.booking_hotel;
  
  if (!hotel) return null;

  return (
    <div className="pdf-section">
      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          <Hotel size={20} />
          {t('hotelInformation')}
        </div>

        {/* Informations générales de l'hôtel */}
        <div style={styles.infoGrid}>
          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('hotelName')}</div>
            <div style={styles.infoValue}>
              <Building2 size={16} />
              {voucherData.product?.name || t('notAvailable')}
            </div>
          </div>

          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('address')}</div>
            <div style={styles.infoValue}>
              <MapPin size={16} />
              {voucherData.product?.address || t('notAvailable')}
            </div>
          </div>

          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('stayPeriod')}</div>
            <div style={styles.infoValue}>
              <Calendar size={16} />
              {formatDate(voucherData.checkin)} → {formatDate(voucherData.checkout)}
            </div>
          </div>

          <div style={styles.infoItem}>
            <div style={styles.infoLabel}>{t('nights')}</div>
            <div style={styles.infoValue}>
              {hotel.nights || voucherData.duration} {t('nights')}
            </div>
          </div>

          {voucherData.product?.phone && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('phone')}</div>
              <div style={styles.infoValue}>
                {voucherData.product.phone}
              </div>
            </div>
          )}

          {hotel.meal_name && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('mealPlan')}</div>
              <div style={styles.infoValue}>
                <Coffee size={16} />
                {hotel.meal_name}
              </div>
            </div>
          )}

          {voucherData.product?.city?.name && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('city')}</div>
              <div style={styles.infoValue}>
                {voucherData.product.city.name}
              </div>
            </div>
          )}

          {voucherData.product?.country?.name && (
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>{t('country')}</div>
              <div style={styles.infoValue}>
                {voucherData.product.country.name}
              </div>
            </div>
          )}
        </div>

        {/* Détails d'occupation */}
        <div style={styles.qrContainer}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Users size={18} />
            {t('occupancyDetails')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '16px'
          }}>
            {/* Adults */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('adults')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {hotel?.adult_count || 0}
              </div>
            </div>

            {/* Children */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('children')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {hotel?.child_count || 0}
              </div>
            </div>

            {/* Rooms */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('rooms')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {hotel?.rooms_count || 0}
              </div>
            </div>

            {/* Total Occupants */}
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                {t('totalOccupants')}
              </div>
              <div style={{
                fontSize: '28px',
                fontWeight: 'bold',
                lineHeight: '1'
              }}>
                {(hotel?.adult_count || 0) + (hotel?.child_count || 0)}
              </div>
            </div>
          </div>
        </div>

        {/* Détails des chambres */}
        {hotel.rooms && hotel.rooms.length > 0 && (
          <div style={{
            marginTop: '24px',
            padding: '20px',
            background: '#f8fafc',
            borderRadius: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 16px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <Bed size={18} />
              {t('roomDetails')} ({hotel.rooms.length})
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: '16px'
            }}>
              {hotel.rooms.map((room, index) => (
                <div key={index} style={{
                  background: 'white',
                  borderRadius: '8px',
                  padding: '16px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '5px'
                  }}>
                    <div>
                      <div style={{
                        fontSize: '15px',
                        fontWeight: '600',
                        color: '#1f2937',
                        marginBottom: '4px'
                      }}>
                        {room.name || `${t('room')} ${index + 1}`}
                      </div>

                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#6b7280',
                      background: '#f3f4f6',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontWeight: '500'
                    }}>
                      {room.count || 1} {room.count > 1 ? t('rooms') : t('room')}
                    </div>
                  </div>
                      {room.bed_type && (
                        <div style={{
                          fontSize: '12px',
                          color: '#6b7280',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          marginBottom: '5px'
                        }}>
                          <Bed size={12} />
                          {room.bed_type}
                        </div>
                      )}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '12px',
                    fontSize: '14px'
                  }}>
                    <div>
                      <div style={{ color: '#6b7280', marginBottom: '2px' }}>
                        {t('occupants')}
                      </div>
                      <div style={{ color: '#1f2937', fontWeight: '500' }}>
                        {room.adult || 0} {t('adults')}
                        {room.child > 0 && ` + ${room.child} ${t('children')}`}
                      </div>
                    </div>

                    <div>
                      <div style={{ color: '#6b7280', marginBottom: '2px' }}>
                        {t('price')}
                      </div>
                      <div style={{ color: '#6b7280', fontWeight: '600' }}>
                        {room.amount?.toLocaleString()} {voucherData.currency}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Informations complémentaires */}
        {(voucherData.policies?.length > 0 || voucherData.extra_includes?.length > 0 || voucherData.extra_excludes?.length > 0) && (
          <div style={{
            marginTop: '24px',
            padding: '20px',
            background: '#f8fafc',
            borderRadius: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#374151',
              margin: '0 0 16px 0'
            }}>
              {t('additionalInformation')}
            </h3>

            {/* Commentaires sur le tarif */}
            {voucherData.policies?.length > 0 && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  {t('rateComments')}
                </div>
                {voucherData.policies.map((policy, index) => (
                  <div key={index} style={{
                    fontSize: '14px',
                    color: '#4b5563',
                    marginBottom: '8px',
                    lineHeight: '1.5',
                    paddingLeft: '16px',
                    position: 'relative'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: '#6b7280'
                    }}>
                      •
                    </span>
                    {policy.value}
                  </div>
                ))}
              </div>
            )}

          </div>
        )}
      </div>
    </div>
  );
};

export default EditHotel;